import { RecordPreview } from "../components/RecordPreview";
import type { LandingContent } from "../content/types";

type ShowcaseSectionProps = {
  showcase: LandingContent["showcase"];
};

export function ShowcaseSection({ showcase }: ShowcaseSectionProps) {
  return (
    <section className="showcase-section">
      <div className="page-container showcase-stack">
        <div className="section-heading">
          <h2>{showcase.title}</h2>
          <p>{showcase.description}</p>
        </div>
        <ol className="showcase-grid">
          {showcase.steps.map((step) => (
            <li className="showcase-card" key={step.title}>
              <RecordPreview state={step.preview} label={step.title} />
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
